import {useTranslation} from "react-i18next";
import cronstrue from "cronstrue";
import "cronstrue/locales/de";

interface MailScheduleHintProps {
    // Raw dispatch-scheduler cron from the BFF; omitted / unparseable → no hint
    // (never show a broken one).
    sendCron?: string;
}

// cronstrue turns the scheduler cron into a localized phrase ("Um 08:00 und 14:00",
// "Alle 30 Minuten"). 24h format keeps it German-natural; unknown locales fall back
// to English.
const formatSchedule = (cron: string, language: string): string | null => {
    try {
        return cronstrue.toString(cron, {
            locale: language.startsWith("de") ? "de" : "en",
            use24HourTimeFormat: true,
        });
    } catch {
        return null;
    }
};

// Quiet "Automatischer Mailversand: …" hint below the mail tables — shared by the
// campaigns section (active customer) and the mail history (deleted customer).
const MailScheduleHint = ({sendCron}: MailScheduleHintProps) => {
    const {t, i18n} = useTranslation();

    const schedule = sendCron ? formatSchedule(sendCron, i18n.language) : null;
    if (!schedule) return null;

    return (
        <p className="mt-3 ml-2 text-xs text-an-muted-2">
            {t("crm.mailHistory.scheduleHint", {schedule})}
        </p>
    );
};

export default MailScheduleHint;
